import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { FormElementStyle } from '../../../form-element-style';
import { PasswordRuleStatus } from '../types/password-rule-status';
import { PasswordRuleCheckerRule } from './rule';
const b = bemClassBuilder('v-password-rule-checker-rule-list');
export const PasswordRuleCheckerRuleList = observer(props => {
    const { rules, password, style } = props;
    return (_jsx("ul", Object.assign({ className: b.block() }, { children: rules.map((rule, index) => (_jsx(PasswordRuleCheckerRule, { rule: rule, status: getRuleStatus(rule, password, style) }, index))) })));
});
PasswordRuleCheckerRuleList.displayName = 'PasswordRuleCheckerRuleList';
const getRuleStatus = (rule, value, style) => {
    const regex = new RegExp(rule.regExpression);
    const isValid = value ? regex.test(value) : false;
    if (isValid)
        return PasswordRuleStatus.Valid;
    return style === FormElementStyle.Error ? PasswordRuleStatus.Invalid : PasswordRuleStatus.Initial;
};
